// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ij-0";